export default __webpack_public_path__ + "static/media/trend-none.151ed4f6.svg";